import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { injectIntl, intlShape } from 'react-intl';
import { pageView, DocumentTitleActions } from '@spm/core';
import DocumentTitleManagerContainer from '../DocumentTitleManager/DocumentTitleManagerContainer';
import translations from './RoutesMessages';
/**
 * The TitledRoute component adds a meaningful title to pages.
 *
 * @class TitledRoute
 * @extends {Component}
 */

var TitledRoute = /*#__PURE__*/function (_React$Component) {
  _inherits(TitledRoute, _React$Component);

  var _super = _createSuper(TitledRoute);

  function TitledRoute() {
    _classCallCheck(this, TitledRoute);

    return _super.apply(this, arguments);
  }

  _createClass(TitledRoute, [{
    key: "shouldComponentUpdate",

    /**
     * The shouldComponentUpdate is called before updates occur. The TitledRoute shouldComponentUpdate
     * prevents double rendering (mounting and then updating) for pages when the URL has been directly
     * or the page has been explicitly reloaded.
     *
     * See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
     *
     * @param nextProps The component next properties.
     * @memberof TitledRoute
     */
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          isIEG = _this$props.isIEG,
          title = _this$props.title;

      if (!isIEG && title.id === nextProps.title.id) {
        return false;
      }

      return true;
    }
    /**
     * Renders the TitledRoute element content.
     *
     * See https://reactjs.org/docs/react-component.html#render
     *
     * @memberof TitledRoute
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          intl = _this$props2.intl,
          isIEG = _this$props2.isIEG,
          title = _this$props2.title,
          setDocumentTitle = _this$props2.setDocumentTitle,
          rest = _objectWithoutProperties(_this$props2, ["intl", "isIEG", "title", "setDocumentTitle"]);

      var _window = window,
          location = _window.location;

      if (!isIEG) {
        // IEG page titles are handled by the BaseFormContainer
        var nextTitle = intl.formatMessage(translations.titleConstruct, {
          title: intl.formatMessage(title)
        });
        setDocumentTitle(nextTitle); // sets and announces page title to screen readers. necessary for SPAs

        pageView({
          title: document.title,
          location: location.href,
          path: location.pathname
        });
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DocumentTitleManagerContainer, null), /*#__PURE__*/React.createElement(Route, rest));
    }
  }]);

  return TitledRoute;
}(React.Component);

TitledRoute.propTypes = process.env.NODE_ENV !== "production" ? {
  component: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  isIEG: PropTypes.bool,
  setDocumentTitle: PropTypes.func,
  title: PropTypes.shape({
    defaultMessage: PropTypes.string,
    id: PropTypes.string
  }).isRequired
} : {};
TitledRoute.defaultProps = {
  isIEG: false,
  setDocumentTitle: function setDocumentTitle() {}
};
/**
 * Redux action creators that will be merged into the component props.
 *
 * @export
 * @param {any} dispatch the dispatch function
 * @memberof TitledRoute
 * @returns the action creators
 */

export function mapDispatchToProps(dispatch) {
  return {
    setDocumentTitle: function setDocumentTitle(documentTitle) {
      DocumentTitleActions.setDocumentTitle(dispatch, documentTitle);
    }
  };
}
/**
 * Adds a meaningful title to a page within the application that is mapped to a specified route.
 * Meaningful page titles provide context to a user about where they currently are within the application and
 * are a key accessibility requirement. The page title is displayed within the current browser tab where
 * the application is running.
 *
 * @param {Component} component The component that is mapped to the route. It is mandatory.
 * @param {string} title A react-intl message that will dynamically prefix the application title with the page title
 * in order to provide a meaningful page title. It is mandatory.
 */

export default connect(null, mapDispatchToProps)(injectIntl(TitledRoute));